import script from "./WaitTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./WaitTable.vue?vue&type=script&lang=ts&setup=true"

export default script